const development: boolean = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

let environment = {
  production: false,
  authenticationServer: 'https://services.scaleup.com.br/authentication',
  transactionalServer: 'https://services.scaleup.com.br/transacional',
  appServer: 'https://services.scaleup.com.br/app',
  reports: 'https://services.scaleup.com.br/reports',
  backoffice: 'https://services.scaleup.com.br/backoffice',
  medias: 'https://services.scaleup.com.br/backoffice/v1/medias/publics',
  stream: 'https://stream.scaleup.com.br/player/v1',
  storybook: 'http://player.scaleup.com.br:6006',
};

if (!development) {
  environment = {
    production: true,
    authenticationServer: 'https://services.scaleup.com.br/authentication',
    transactionalServer: 'https://services.scaleup.com.br/transacional',
    appServer: 'https://services.scaleup.com.br/app',
    reports: 'https://services.scaleup.com.br/reports',
    backoffice: 'https://services.scaleup.com.br/backoffice',
    medias: 'https://services.scaleup.com.br/backoffice/v1/medias/publics',
    stream: 'https://stream.scaleup.com.br/player/v1',
    storybook: 'https://player-designsystem.scaleup.com.br',
  };
}

export default environment;
